// extracted by mini-css-extract-plugin
export default {"external":"aLINgC","callToActionText":"bLINgC"};